import script from "./SchoolEnrollmentLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolEnrollmentLanding.vue?vue&type=script&setup=true&lang=js"

import "./SchoolEnrollmentLanding.vue?vue&type=style&index=0&id=608d5e9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-608d5e9c"]])

export default __exports__